import { render } from "./HelpFAQQuestion.vue?vue&type=template&id=62670a5b&scoped=true"
import script from "./HelpFAQQuestion.vue?vue&type=script&lang=js"
export * from "./HelpFAQQuestion.vue?vue&type=script&lang=js"

import "./HelpFAQQuestion.vue?vue&type=style&index=0&id=62670a5b&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62670a5b"]])

export default __exports__